// extracted by mini-css-extract-plugin
export default {"input":"input_input__2CTnp","textarea":"input_textarea__+u8GS","button":"input_button__Idhgp"};